// Dependencies
import React, { useState, useEffect, useRef, useCallback, useContext } from "react";

import { ReactSVG } from "react-svg";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CSSTransitionProps } from "react-transition-group/CSSTransition";
import { Portal } from 'react-portal';

// Types
import { Types, Components } from '../types';

// Utils
import { WP_PLUGIN_BASE_PATH } from '../utils/config'

// Hooks
import { useDebug } from "../hooks";
 
// Components
import { MinicartContext } from "../contexts/Minicart";
import Price from "./Price";

const SidebarFooter = ({ className  }: any) => {
    
    useDebug('SidebarFooter'); 

    // Contexts
    const { loading, itemsSubtotal, itemsCount, config, translations, theme } = useContext( MinicartContext );

    const transitionProps: CSSTransitionProps = React.useMemo(() => ({
        in: itemsCount > 0,
        timeout: Number(theme.general.transition.duration.replace('ms', '')),
        unmountOnExit: true
      }), [theme.general.transition.duration, itemsCount])
    
    return (<>
        <CSSTransition {...transitionProps}>
            <div className={`${className}`}>

                <div className={`${className}__subtotal`}>
                    <span className={`${className}__subtotal--label`}>{translations?.cartFooter.subtotal}</span>
                    <Price
                        {...{ loading }}
                        {...{config, translations, theme}}
                        value={itemsSubtotal} 
                    />
                </div>

                <div className={`${className}__actions`}>
                    <a href={config?.links?.cart?.url} className="wooptima-button">{config?.links?.cart?.label}</a>
                    <a href={config?.links?.checkout?.url} className="wooptima-button wooptima-button--cta">{config?.links?.checkout?.label}</a>
                </div>

            </div>
        </CSSTransition>
    </>)
    
}

export default SidebarFooter;